/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { GetFileResponse } from '../models/get-file-response';
@Injectable({
  providedIn: 'root',
})
class FileService extends __BaseService {
  static readonly FileGetFileByNamePath = '/File/GetFileByName';
  static readonly FileGetFileByIdPath = '/File/GetFileById';
  static readonly FileGenerateWeeklyReportPath = '/File/GenerateWeeklyReport';
  static readonly FileGenerateProcessReportPath = '/File/GenerateProcessReport';
  static readonly FileGenerateCompanyStatsReportPath = '/File/GenerateCompanyStatsReport';
  static readonly FileGetAllPath = '/File/GetAll';
  static readonly FileGetByIdPath = '/File/GetById';
  static readonly FileUploadFilePath = '/File/UploadFile';
  static readonly FileDeletePath = '/File/Delete';
  static readonly FileDeleteRangePath = '/File/DeleteRange';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param params The `FileService.FileGetFileByNameParams` containing the following parameters:
   *
   * - `name`:
   *
   * - `directoryPath`:
   */
  FileGetFileByNameResponse(params: FileService.FileGetFileByNameParams): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.name != null) __params = __params.set('name', params.name.toString());
    if (params.directoryPath != null) __params = __params.set('directoryPath', params.directoryPath.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/File/GetFileByName`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param params The `FileService.FileGetFileByNameParams` containing the following parameters:
   *
   * - `name`:
   *
   * - `directoryPath`:
   */
  FileGetFileByName(params: FileService.FileGetFileByNameParams): __Observable<Blob> {
    return this.FileGetFileByNameResponse(params).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param id undefined
   */
  FileGetFileByIdResponse(id?: string): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (id != null) __params = __params.set('id', id.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/File/GetFileById`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param id undefined
   */
  FileGetFileById(id?: string): __Observable<Blob> {
    return this.FileGetFileByIdResponse(id).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param email undefined
   */
  FileGenerateWeeklyReportResponse(email?: null | string): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (email != null) __params = __params.set('email', email.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/File/GenerateWeeklyReport`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param email undefined
   */
  FileGenerateWeeklyReport(email?: null | string): __Observable<Blob> {
    return this.FileGenerateWeeklyReportResponse(email).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param email undefined
   */
  FileGenerateProcessReportResponse(email?: null | string): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (email != null) __params = __params.set('email', email.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/File/GenerateProcessReport`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param email undefined
   */
  FileGenerateProcessReport(email?: null | string): __Observable<Blob> {
    return this.FileGenerateProcessReportResponse(email).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param email undefined
   */
  FileGenerateCompanyStatsReportResponse(email?: null | string): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (email != null) __params = __params.set('email', email.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/File/GenerateCompanyStatsReport`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param email undefined
   */
  FileGenerateCompanyStatsReport(email?: null | string): __Observable<Blob> {
    return this.FileGenerateCompanyStatsReportResponse(email).pipe(
      __map(_r => _r.body as Blob)
    );
  }
  FileGetAllResponse(): __Observable<__StrictHttpResponse<Array<GetFileResponse>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/File/GetAll`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<GetFileResponse>>;
      })
    );
  }  FileGetAll(): __Observable<Array<GetFileResponse>> {
    return this.FileGetAllResponse().pipe(
      __map(_r => _r.body as Array<GetFileResponse>)
    );
  }

  /**
   * @param Id undefined
   */
  FileGetByIdResponse(Id?: string): __Observable<__StrictHttpResponse<GetFileResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (Id != null) __params = __params.set('Id', Id.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/File/GetById`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<GetFileResponse>;
      })
    );
  }
  /**
   * @param Id undefined
   */
  FileGetById(Id?: string): __Observable<GetFileResponse> {
    return this.FileGetByIdResponse(Id).pipe(
      __map(_r => _r.body as GetFileResponse)
    );
  }

  /**
   * @param params The `FileService.FileUploadFileParams` containing the following parameters:
   *
   * - `File`:
   *
   * - `DirectoryPath`:
   */
  FileUploadFileResponse(params: FileService.FileUploadFileParams): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let __formData = new FormData();
    __body = __formData;
    if (params.File != null) { __formData.append('File', params.File as string | Blob);}
    if (params.DirectoryPath != null) { __formData.append('DirectoryPath', params.DirectoryPath as string | Blob);}
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/File/UploadFile`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  /**
   * @param params The `FileService.FileUploadFileParams` containing the following parameters:
   *
   * - `File`:
   *
   * - `DirectoryPath`:
   */
  FileUploadFile(params: FileService.FileUploadFileParams): __Observable<string> {
    return this.FileUploadFileResponse(params).pipe(
      __map(_r => _r.body as string)
    );
  }

  /**
   * @param id undefined
   */
  FileDeleteResponse(id?: string): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (id != null) __params = __params.set('id', id.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/File/Delete`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param id undefined
   */
  FileDelete(id?: string): __Observable<Blob> {
    return this.FileDeleteResponse(id).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param ids undefined
   */
  FileDeleteRangeResponse(ids: Array<string>): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = ids;
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/File/DeleteRange`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param ids undefined
   */
  FileDeleteRange(ids: Array<string>): __Observable<Blob> {
    return this.FileDeleteRangeResponse(ids).pipe(
      __map(_r => _r.body as Blob)
    );
  }
}

module FileService {

  /**
   * Parameters for FileGetFileByName
   */
  export interface FileGetFileByNameParams {
    name?: null | string;
    directoryPath?: null | string;
  }

  /**
   * Parameters for FileUploadFile
   */
  export interface FileUploadFileParams {
    File?: null | Blob;
    DirectoryPath?: null | string;
  }
}

export { FileService }
